import {z} from "../../../../../lib";
import {schemaEntityWithId} from "../../../../../types";
import {
  OperacionNotaEstructuradaCuentaFields,
  OperacionNotaEstructuradaDetalleFields,
  OperacionNotaEstructuradaFields
} from "./fields";

export const schemaOperacionNotaEstructuradaUpdate = z.object({
  [OperacionNotaEstructuradaFields.CodSectorComercial]: z.number(),
  [OperacionNotaEstructuradaFields.FechaAprobacion]: z.date().optional().nullable(),
  [OperacionNotaEstructuradaFields.FechaVencimiento]: z.date()
})

export type OperacionNotaEstructuradaUpdate = z.infer<typeof schemaOperacionNotaEstructuradaUpdate>


export const schemaOperacionNotaEstructuradaDetalleInsert = z.object({
  [OperacionNotaEstructuradaDetalleFields.LimiteConcertacion]: z.number(),
  [OperacionNotaEstructuradaDetalleFields.LimiteDVP]: z.number(),
  [OperacionNotaEstructuradaDetalleFields.LimiteFOP]: z.number(),
})

export type OperacionNotaEstructuradaDetalleInsert = z.infer<typeof schemaOperacionNotaEstructuradaDetalleInsert>

export const schemaOperacionNotaEstructuradaInsert = z.object({
  [OperacionNotaEstructuradaFields.CodPais]: z.number(),
  [OperacionNotaEstructuradaFields.CodSectorComercial]: z.number(),
  [OperacionNotaEstructuradaFields.FechaAprobacion]: z.date().optional().nullable(),
  [OperacionNotaEstructuradaFields.FechaVencimiento]: z.date(),
  [OperacionNotaEstructuradaFields.BitEnvio]: z.boolean(),
  [OperacionNotaEstructuradaFields.Cuentas]: z.array(
    z.object({
      [OperacionNotaEstructuradaCuentaFields.NroCuenta]: z.string(),
      [OperacionNotaEstructuradaCuentaFields.RazonSocial]: z.string(),
      [OperacionNotaEstructuradaCuentaFields.CodMoneda]: z.number(),
      [OperacionNotaEstructuradaCuentaFields.ImporteConcertacion]: z.number(),
      [OperacionNotaEstructuradaCuentaFields.ImporteDPV]: z.number(),
      [OperacionNotaEstructuradaCuentaFields.ImporteFOP]: z.number()
    })
  )
})

export type OperacionNotaEstructuradaInsert = z.infer<typeof schemaOperacionNotaEstructuradaInsert>

export const schemaOperacionNotaEstructuradaDetalleUpdate = schemaOperacionNotaEstructuradaDetalleInsert.merge(schemaEntityWithId)

export type OperacionNotaEstructuradaDetalleUpdate = z.infer<typeof schemaOperacionNotaEstructuradaDetalleUpdate>

export const schemaOperacionNotaEstructuradaCuentaDetalleUpdate = z.object({
  [OperacionNotaEstructuradaCuentaFields.ImporteConcertacion]: z.number().optional(),
  [OperacionNotaEstructuradaCuentaFields.ImporteDPV]: z.number().optional(),
  [OperacionNotaEstructuradaCuentaFields.ImporteFOP]: z.number().optional()
})

export type OperacionNotaEstructuradaCuentaDetalleUpdate = z.infer<typeof schemaOperacionNotaEstructuradaCuentaDetalleUpdate>